<p>product-configuration works!</p>
